import { useState, useEffect, useCallback } from "react";

const STORAGE_KEY = "recentlyUsedIbic";
const MAX_RECENT = 5;

export const useRecentlyUsedIbic = () => {
    const [recentlyUsed, setRecentlyUsed] = useState<string[]>([]);

    // Load from localStorage on mount
    useEffect(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored) {
                const parsed = JSON.parse(stored);
                if (Array.isArray(parsed)) {
                    setRecentlyUsed(parsed);
                }
            }
        } catch (e) {
            console.error("Failed to load recently used IBIC categories:", e);
        }
    }, []);

    // Add to recently used
    const addRecent = useCallback((category: string) => {
        setRecentlyUsed(prev => {
            // Remove if already exists, add to front, limit to MAX_RECENT
            const updated = [category, ...prev.filter(c => c !== category)].slice(0, MAX_RECENT);

            // Persist to localStorage
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
            } catch (e) {
                console.error("Failed to save recently used IBIC categories:", e);
            }

            return updated;
        });
    }, []);

    // Clear all recently used
    const clearRecent = useCallback(() => {
        setRecentlyUsed([]);
        try {
            localStorage.removeItem(STORAGE_KEY);
        } catch (e) {
            console.error("Failed to clear recently used IBIC categories:", e);
        }
    }, []);

    return { recentlyUsed, addRecent, clearRecent };
};
